module.exports = __webpack_public_path__ + "static/ma-1-sq-ce6a62f1e9fb8bd6dcfda5386e220255.png";